import axiosInstance from "../helpers/axiosInstance";

export const fetchPickingProductivitiesInsights = async (warehouseId) => {
    const res = await axiosInstance.get(`/api/v1/warehouses/${warehouseId}/picking-productivities/insights`);
    return res.data;
};

export const fetchPickingProductivitiesStatsByPicker = async (warehouseId) => {
    const res = await axiosInstance.get(`/api/v1/warehouses/${warehouseId}/picking-productivities/stats-by-picker`);
    return res.data;
};

export const fetchPickingProductivitiesHourlyStats = async (warehouseId) => {
    const res = await axiosInstance.get(`/api/v1/warehouses/${warehouseId}/picking-productivities/hourly-stats`);
    return res.data;
};

export const fetchPickingProductivitiesIntervalStats = async (warehouseId) => {
    const res = await axiosInstance.get(`/api/v1/warehouses/${warehouseId}/picking-productivities/interval-stats`);
    return res.data;
};
